import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { YOUTH_CLASSES as Y } from "../data/youthClasses";

export default function YouthClassesCTA() {
  return (
    <section className="border-t border-border" data-testid="home-youth-classes">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 md:py-24 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center">
        <div className="md:col-span-7">
          <p className="label mb-3">Education · Denver</p>
          <h2 className="serif text-3xl md:text-5xl tracking-tight font-light leading-[1.05]">
            You Are An Artist! <span className="italic text-[hsl(var(--ink-soft))]">Youth Art Studio</span>
          </h2>
          <p className="mt-5 max-w-xl text-[hsl(var(--ink-soft))] leading-relaxed">
            Artist and DPS educator Joseph Graves Jr. is forming a small youth art program in Denver. Join the
            interest list for drawing, painting, and mixed-media classes for ages 8 to 12.
          </p>
        </div>
        <div className="md:col-span-5 md:text-right">
          <dl className="inline-grid grid-cols-[auto_1fr] gap-x-6 gap-y-1.5 text-left text-sm mb-6">
            {Y.facts.slice(0, 3).map((f) => (
              <React.Fragment key={f.k}>
                <dt className="label text-[hsl(var(--ink-soft))]">{f.k}</dt>
                <dd>{f.v}</dd>
              </React.Fragment>
            ))}
          </dl>
          <div>
            <Link
              to="/youth-art-classes"
              className="inline-flex items-center gap-3 bg-foreground text-background px-8 py-4 text-xs uppercase tracking-[0.18em] hover:opacity-90 transition-opacity"
              data-testid="home-youth-classes-link"
            >
              Learn more <ArrowRight className="h-3.5 w-3.5" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
